import Service from "../../AuthService";

const ProductType = {
    getProductType() {
        return Service.get("/product-type");
    },
    getProduct() {
        return Service.get("/overview-get-product");
    },
    productTypeSpecial() {
        return Service.get("/list_special");
    }
};
export default ProductType;
